import ResourceGet from '../../resource/get';

const DevicesGet = () => {

      return(
        <div>
          <ResourceGet resource="devices" name="Devices" />
        </div>
      )

}

export default DevicesGet;
